import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class EquipamentoRdService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
        this.urlBase = `${SCAMP_API.accountApiV1}/rd-equipamentos`;
    }
    add(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/rd-equipamentos`, data, { headers: this.account.composeHeaders() });
    }
    /* addPromise(data: any) {
  
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      //myHeaders.append("header", this.account.getHearderAuthorization())
  
  
        var requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: JSON.stringify(data),
          redirect: 'follow'
        };
  
       return  fetch("https://localhost:5001/v1/rd-equipamentos", requestOptions);
  
    } */
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/rd-equipamentos/${id}`, { headers: this.account.composeHeaders() });
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/rd-equipamentos`, { headers: this.account.composeHeaders() });
    }
    getAllWithDet(rdId) {
        return this.http.get(`${SCAMP_API.accountApiV1}/rd-equipamentos/with-det/${rdId}`, { headers: this.account.composeHeaders() });
    }
    getAllWithDetPromise(rdId) {
        const url = `${this.urlBase}/with-det/${rdId}`;
        return fetch(url, {
            method: 'GET',
            headers: this.account.getHearderAuthorization()
        });
    }
    deleteById(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/rd-equipamentos/${id}`, { headers: this.account.composeHeaders() });
    }
    isUniqueNome(nome, id) {
        return this.http.post(`${SCAMP_API.accountApiV1}/rd-equipamentos/is-unique`, { nome, id }, { headers: this.account.composeHeaders() });
    }
}
EquipamentoRdService.ngInjectableDef = i0.defineInjectable({ factory: function EquipamentoRdService_Factory() { return new EquipamentoRdService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: EquipamentoRdService, providedIn: "root" });
